import {css, html, LitElement} from "lit";
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from "pwa-helpers";

import {
    TaxRegime,
    CFDI,
    Region,
    PersonType,
    DocumentType,
    City,
    Representacion,
    getTaxRegimeOptions,
    getCFDIOptions,
    getPersonTypeOptions,
    getDocumentTypeOptions,
    getRegions,
    getCities,
    getRepresentations, IdentificationType, getIdentificationTypeOptions, TaxInfoDetails
} from './tax-info-options';
import variables from "../../common/styles/variables";
import store from "../../store/store";
import { isTunnelPurchaseFlow, wait } from '../../common/utils/util';
import { getTaxInfo, updateTaxInfo } from "../checkout/shop-checkout";
import { StoreState } from "../../store/store.interface";
import { MessageType } from '../alert/global-message.interface';
import { PAYMENT_MESSAGE_ID, updateGlobalMessage } from '../alert/global-message';

@customElement('mhecomm-tax-info')
export class TaxInfo extends connect(store)(LitElement) {
    static styles = [
        variables,
        css`
            .focusedAddress {
                background-color: var(--mh-light-gray-2);
            }
           `
    ];

    @property()
    country = '';

    @property()
    userInternalErrorMessageModel = false;

    @state()
    private uxtIconReady = false;

    @state()
    private forceShowValidationMessages = false;

    @state()
    private showDependentFields = false;

    @state()
    private spain = 'ES';

    @state()
    private colombia = 'CO';

    @state()
    private mexico = 'MX';

    @state()
    private taxIdLabel = 'Tax Id';

    @state()
    private taxId = '';

    @state()
    private isTaxIdDisabled = false;

    @state()
    private isTaxIdValid =  true;

    @state()
    private isTaxIdPristine =  true;

    @state()
    private taxIdMaxLength: number | undefined;

    @state()
    private isTaxIdRequired = false;

    @state()
    private taxErrorMessage: string | undefined;

    @state()
    private nameOnInvoiceLabel = 'Name on Invoice / Nombre a Facturar';

    @state()
    private name = '';

    @state()
    private nameOnInvoiceErrorMessage = "Please enter name on invoice.";

    @state()
    private isNameOnInvoiceValid = true;

    @state()
    private isNameOnInvoiceRequired =  false;

    @state()
    private isNameOnInvoicePristine = true;

    @state()
    private postalCodeLabel = 'Zip Code / Código Postal';

    @state()
    private postalCode = '';

    @state()
    private postalCodeErrorMessage: string | undefined;

    @state()
    private isPostalCodeValid =  true;

    @state()
    private isPostalCodePristine = true;

    @state()
    private isPostalCodeRequired = false;

    @state()
    private taxRegimeLabel = 'Tax Regime / Régimen Fiscal';

    @state()
    private taxRegimeOptions: TaxRegime[] = [];

    @state()
    private selectedTaxRegime: TaxRegime | undefined;

    @state()
    private isTaxRegimeValid = true;

    @state()
    private isTaxRegimePristine = true;

    @state()
    private taxRegimeErrorMessage: string | undefined;

    @state()
    private cfdiLabel = 'Tax Receipt Use / Uso de CFDI';

    @state()
    private cfdiOptions: CFDI[] = [];

    @state()
    private isCfdiValid = true;

    @state()
    private isCfdiPristine = true;

    @state()
    private cfdiErrorMessage: string | undefined;

    @state()
    private selectedCfdi: CFDI | undefined;

    @state()
    private personTypeLabel = 'Type of Person / Tipo de Persona';

    @state()
    private personTypeOptions: PersonType[] = [];

    @state()
    private selectedPersonType: PersonType | undefined;

    @state()
    private isPersonTypeValid = true;

    @state()
    private isPersonTypePristine = true;

    @state()
    private personTypeErrorMessage: string | undefined;

    @state()
    private documentTypeLabel = 'Type of Document / Tipo de Identificación';

    @state()
    private documentTypeOptions: DocumentType[] = [];

    @state()
    private isDocumentTypeValid = true;

    @state()
    private isDocumentTypePristine = true;

    @state()
    private selectedDocumentType: DocumentType | undefined;

    @state()
    private documentTypeErrorMessage: string | undefined;

    @state()
    private regionLabel = 'State / Región';

    @state()
    private regionOptions: Region[] = [];

    @state()
    private selectedRegion: Region | undefined;

    @state()
    private isRegionValid = true;

    @state()
    private isRegionPristine = true;

    @state()
    private regionErrorMessage: string | undefined;

    @state()
    private cityLabel = 'City / Municipio';

    @state()
    private cityOptions: City[] = [];

    @state()
    private selectedCity: City | undefined;

    @state()
    private isCityValid = true;

    @state()
    private isCityPristine = true;

    @state()
    private isCityDisabled = true;

    @state()
    private cityErrorMessage: string | undefined;

    @state()
    protected citySelectedIndex = 0;

    @state()
    private representationLabel = 'Representation Code / Código de Representación';

    @state()
    private representationOptions: Representacion[] = [];

    @state()
    private selectedRepresentation: Representacion | undefined;

    @state()
    private isRepresentationValid = true;

    @state()
    private isRepresentationPristine = true;

    @state()
    private representationErrorMessage: string | undefined;

    @state()
    private identificationTypeLabel = 'Tax Identification Type / Tipo de Identificación Fiscal';

    @state()
    private identificationTypeOptions: IdentificationType[] = [];

    @state()
    private selectedIdentificationType: IdentificationType | undefined;

    @state()
    private isIdentificationTypeValid = true;

    @state()
    private isIdentificationTypePristine = true;

    @state()
    private identificationTypeErrorMessage: string | undefined;

    @state()
    private formClass = '';

    @state()
    private taxInfoTitleClass = 'vectipede-book text-info';

    @state()
    private labelFieldClass = 'control-label';

    @state()
    private selectFieldClass = 'form-control';

    @state()
    private taxErrorAlertMessage: string = "Required fields are missing information. Please make sure you’ve completed each field correctly before trying again.";

    @state()
    private taxIdTouched = false;

    @state()
    private nameOnInvoiceTouched = false;

    @state()
    private postalCodeTouched = false;

    connectedCallback() {
        super.connectedCallback();
        if(this.isSupportedCountry()){
            this.taxRegimeOptions = getTaxRegimeOptions(this.country)
            this.cfdiOptions = getCFDIOptions(this.country)
            this.personTypeOptions = getPersonTypeOptions(this.country)
            this.documentTypeOptions = getDocumentTypeOptions(this.country)
            this.regionOptions = getRegions(this.country)
            this.representationOptions = getRepresentations(this.country)

            if (this.country == this.mexico) {
                this.taxIdLabel += ' / RFC';
                this.isTaxIdRequired = false;
                this.taxIdMaxLength = 13;
                this.taxErrorMessage = "Tax Id must have 12 or 13 numbers or letters.";
            } else if(this.country == this.colombia) {
                this.taxIdLabel += ' / NIT / CC';
                this.isTaxIdRequired = false;
                this.taxIdMaxLength = 10;
                this.taxErrorMessage = "Tax Id must be 10 digits or less and include only numbers.";
            } else if(this.country == this.spain) {
                this.taxIdLabel += ' / DNI / CIF';
                this.isTaxIdRequired = true;
                this.taxIdMaxLength = 9;
                this.taxErrorMessage = "Tax Id must have 9 numbers or letters / El número de identificación fiscal debe tener 9 números o letras.";
                this.identificationTypeErrorMessage = "Select a valid Tax Identification Type / Tipo de Identificación Fiscal."
                this.isTaxIdDisabled = true;
                this.identificationTypeOptions = getIdentificationTypeOptions(this.country);
            }

            this.nameOnInvoiceErrorMessage = this.getErrorMessage(this.nameOnInvoiceLabel, 'enter');
            this.postalCodeErrorMessage = this.getErrorMessage(this.postalCodeLabel, 'enter');
            this.taxRegimeErrorMessage = this.getErrorMessage(this.taxRegimeLabel, 'select');
            this.cfdiErrorMessage = this.getErrorMessage(this.cfdiLabel, 'select');
            this.personTypeErrorMessage = this.getErrorMessage(this.personTypeLabel, 'select');
            this.documentTypeErrorMessage = this.getErrorMessage(this.documentTypeLabel, 'select');
            this.regionErrorMessage = this.getErrorMessage(this.regionLabel, 'select');
            this.cityErrorMessage = this.getErrorMessage(this.cityLabel, 'select');
            this.representationErrorMessage = this.getErrorMessage(this.representationLabel, 'select');

            // Remove this after upgrading LitElement. See details here: https://github.mheducation.com/MHEducation/ecomm-ui/pull/202#issue-249839
            window.customElements.whenDefined('uxt-icon').then(() => this.uxtIconReady = true);
        }

        if (isTunnelPurchaseFlow()) {
            this.formClass = 'p-3';
            this.taxInfoTitleClass = 'h4 flex-grow-1';
            this.labelFieldClass = 'form-label';
            this.selectFieldClass = 'form-select';
            this._updateTaxInfoForm();
        }
    }

    _updateTaxInfoForm() {
        const taxInfo = getTaxInfo(store.getState() as StoreState);
        if(taxInfo) {
            if(this.country === this.spain) {
                this.updateIdentificationTypeValue(taxInfo.selectedIdentificationType?.id);
            }
            this.updateTaxIdValue(taxInfo.taxId! || '');
            this.updateNameOnInvoiceValue(taxInfo.name! || '');
            this.updatePostalCodeValue(taxInfo.postalCode! || '');
            this.updatePersonTypeValue(taxInfo.selectedPersonType?.id);
            this.updateDocumentTypeValue(taxInfo.selectedDocumentType?.id);
            this.updateRegionValue(taxInfo.selectedRegion?.id);
            this.updateCityValue(taxInfo.selectedCity?.id);
            this.updateRepresentationValue(taxInfo.selectedRepresentation?.id);
            this.updateTaxRegimeValue(taxInfo.selectedTaxRegime?.id);
            this.updateCfdiValue(taxInfo.selectedCfdi?.id);
        }
    }

    getFormData() {
        return {
            taxId : this.taxId,
            name : this.name,
            postalCode : this.postalCode,
            selectedCfdi : this.selectedCfdi,
            selectedPersonType : this.selectedPersonType,
            selectedDocumentType : this.selectedDocumentType,
            selectedRegion : this.selectedRegion,
            selectedCity : this.selectedCity,
            selectedRepresentation : this.selectedRepresentation,
            selectedTaxRegime : this.selectedTaxRegime,
            isValid: this.isTaxIdValid && this.isNameOnInvoiceValid &&
              this.isPostalCodeValid && this.isTaxRegimeValid &&
              this.isCfdiValid && this.isPersonTypeValid &&
              this.isDocumentTypeValid && this.isRegionValid &&
              this.isCityValid && this.isRepresentationValid,
            isTaxIdValid: this.isTaxIdValid,
            isNameOnInvoiceValid: this.isNameOnInvoiceValid,
            isPostalCodeValid: this.isPostalCodeValid,
            isTaxRegimeValid: this.isTaxRegimeValid,
            isCfdiValid: this.isCfdiValid,
            isPersonTypeValid : this.isPersonTypeValid,
            isDocumentTypeValid : this.isDocumentTypeValid,
            isRegionValid : this.isRegionValid,
            isCityValid: this.isCityValid,
            isRepresentationValid : this.isRepresentationValid
        }
    }

    getMockedFormData() {
        return {
            taxId : '1234',
            name : 'Lorem Ipsum',
            postalCode : '00001',
            selectedCfdi : { id: 'G01', description: 'Adquisición de mercancías'},
            selectedPersonType :           { id: 1, description: 'Persona juridica'},
            selectedDocumentType : { id: 3, description: 'Cédula de ciudadanía'},
            selectedRegion :  { id: 91, description: 'Amazonas'},
            selectedRepresentation : { id: '01', name: 'Administrador judicial', description:'Persona designada por autoridad competente para administrar la comunidad, cuando los comuneros no se avinieren en el manejo del bien común.'} ,
            selectedTaxRegime : { id: 622, description:'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', country: 'MX'},
            isValid: true,
            isTaxIdValid: true,
            isNameOnInvoiceValid: true,
            isTaxRegimeValid: true,
            isCfdiValid: true,
            isPostalCodeValid: true,
            isPersonTypeValid : true,
            isDocumentTypeValid : true,
            isRegionValid : true,
            isCityValid: true,
            isRepresentationValid : true
        }
    }

    render() {
        if (!this.isSupportedCountry()) {
            return html``;
        }

        return html`
        ${isTunnelPurchaseFlow()
          ? html`
              <div class="d-flex bg-light pt-3 pb-2 px-3">
                <h2 class="${this.taxInfoTitleClass}">Tax Details / Datos de Facturación</h2>
              </div>
            `
          : html`<h2 class="${this.taxInfoTitleClass}">Tax Details / Datos de Facturación</h2>`
        }
        
        <div class="row g-3 ${this.formClass}">
          ${this.loadForm()}
        </div>
      `
    }

    /**
     *
     * Remove shadow DOM
     * @returns
     */
    createRenderRoot() {
        return this;
    }

    displayDependentFields() {
        if(this.showDependentFields) {
            return;
        }
        this.showDependentFields = true;
        if (this.country == this.mexico || this.country == this.colombia) {
            this.isNameOnInvoiceValid = false;
            this.isNameOnInvoiceRequired = true;

            this.isPostalCodeValid = false;
            this.isPostalCodeRequired = true;

            this.isTaxRegimeValid = false;
        }

        if (this.country == this.mexico) {
            this.isCfdiValid = false;
        }

        if(this.country == this.colombia) {
            this.isPersonTypeValid = false;
            this.isDocumentTypeValid = false;
            this.isRegionValid = false;
            this.isCityValid = false;
            this.isRepresentationValid = false;
            this.renderCityField()
        }
    }

    hideDependentFields() {
        if(!this.showDependentFields) {
            return;
        }
        this.showDependentFields = false;
        if(this.country == this.mexico || this.country == this.colombia) {
            this.name = '';
            this.isNameOnInvoiceValid = true;
            this.isNameOnInvoicePristine = true;

            this.postalCode = '';
            this.isPostalCodeValid = true;
            this.isPostalCodeRequired = false;
            this.isPostalCodePristine = true;

            this.selectedTaxRegime = undefined;
            this.isTaxRegimeValid = true;
            this.isTaxRegimePristine = true;

            this.selectedCfdi = undefined;
            this.isCfdiValid = true;
            this.isCfdiPristine = true;

            this.selectedPersonType = undefined;
            this.isPersonTypeValid = true;
            this.isPersonTypePristine = true;

            this.selectedDocumentType = undefined;
            this.isDocumentTypeValid = true;
            this.isDocumentTypePristine = true;

            this.selectedRegion = undefined;
            this.isRegionValid = true;
            this.isRegionPristine = true;

            this.selectedCity = undefined;
            this.isCityValid = true;
            this.isCityPristine = true;
            this.isCityDisabled = true;

            this.selectedRepresentation = undefined;
            this.isRepresentationValid = true;
            this.isRepresentationPristine = true;
        }
    }

    updateForceShowValidationMessages(value: boolean) {
        this.forceShowValidationMessages = value;
    }

    getErrorMessage(label: string, action: string | 'enter') {
        return  "Please " + action + " " + label + ".";
    }

    getMessageErrorComponent(id: string, message: string | undefined) {
        if (!message || !message.length) {
            return html`
                <p id="${id}" class="visually-hidden" role="alert" aria-live="assertive"></p>
            `;
        }
        
        if (this.userInternalErrorMessageModel) {
            return html`
        <p class="invalid-feedback mb-1 d-block" id="${id}" role="alert" aria-live="assertive">
            ${this.uxtIconReady ? html`<uxt-icon icon="exclamation-triangle" aria-hidden="true"></uxt-icon>` : ''}
            <span class="visually-hidden">Error: </span>
            ${message}
        </p>`;
        }
        return html`
            <div class="clear form-error-msg keep-error-msg" id="${id}" role="alert" aria-live="assertive">
                <span class="shop-icon icon" aria-hidden="true">r</span>
                <span class="visually-hidden">Error: </span>
                ${message}
            </div>`;
    }

    renderIdentificationType() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectIdentificationType" class="${this.labelFieldClass}">${this.identificationTypeLabel}</label>
                    <div class="select-wrapper">
                        <select
                            id="selectIdentificationType"
                            .value="${this.selectedIdentificationType?.id || ''}"
                            class="${this.selectFieldClass} ${!this.isIdentificationTypeValid && !this.isIdentificationTypePristine ? 'is-invalid': ''}"
                            @change=${(_e) => this.updateIdentificationTypeValue((_e.target as HTMLInputElement).value)}
                            aria-required="true">
                            <option value="${undefined}" ?selected=${this.selectedIdentificationType === undefined}>Select</option>
                            ${this.identificationTypeOptions.map(option => html`
                                <option value="${option.id}" ?selected=${this.selectedIdentificationType === option}>${option.description}</option>
                            `)}
                        </select>
                        ${this.getMessageErrorComponent('identification-type-error', !this.isIdentificationTypeValid && (!this.isIdentificationTypePristine || this.forceShowValidationMessages) ? this.identificationTypeErrorMessage : '')}
                    </div>
                </div>
            </div>
        `
    }

    updateIdentificationTypeValue(value) {
        const selected = Number(value);
        this.selectedIdentificationType = this.identificationTypeOptions.filter(value => value.id === selected)[0];
        this.isIdentificationTypePristine = false
        if (!this.selectedIdentificationType) {
            this.isIdentificationTypeValid = false;
            this.isTaxIdDisabled = true;
        } else {
            this.isIdentificationTypeValid = true;
            this.isTaxIdDisabled = this.isResidentOutsideOfSpain();
            this.isTaxIdRequired = !this.isTaxIdDisabled;
        }

        if (this.isTaxIdDisabled) {
            this.updateTaxIdValue("");
        }

        if (!this.isTaxIdPristine) {
            this.updateTaxIdValue(this.taxId);
        }
    }

    isResidentOutsideOfSpain() {
        return !!this.selectedIdentificationType && this.selectedIdentificationType.id == 4;
    }

    isSpanishCitizen() {
        return !!this.selectedIdentificationType && this.selectedIdentificationType.id == 1;
    }

    isSpainResident() {
        return !!this.selectedIdentificationType && this.selectedIdentificationType.id == 2;
    }

    isSpainCompany() {
        return !!this.selectedIdentificationType && this.selectedIdentificationType.id == 3;
    }

    renderTaxId() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="taxId" class="${this.labelFieldClass}">${this.taxIdLabel}${this.isTaxIdRequired || this.isTaxIdDisabled ? '' : ' (optional)'  }</label>
                    <input
                      type="text"
                      class="form-control ${(!this.isTaxIdValid && this.taxIdTouched) ? 'is-invalid': ''}"
                      id="taxId"
                      required="${this.isTaxIdRequired}"
                      aria-required="true"
                      maxlength="${this.taxIdMaxLength}"
                      ?disabled=${this.isTaxIdDisabled}
                      .value="${this.taxId}"
                      @blur=${this._handleTaxIdBlur}
                      @input=${(_e: InputEvent) => this.updateTaxIdValue((_e.target as HTMLInputElement).value)}
                      aria-invalid="${(!this.isTaxIdValid && this.taxIdTouched).toString()}"
                      aria-describedby="tax-id-error"
                    />
                    ${this.getMessageErrorComponent('tax-id-error', (!this.isTaxIdValid && this.taxIdTouched) ? this.taxErrorMessage : '')}
                </div>
            </div>
        `;
    }

    updateTaxIdValue(taxId: string) {
        this.isTaxIdValid = this.validateTaxId(taxId);
        this.isTaxIdPristine = false;
        this.taxId = taxId;

        if(isTunnelPurchaseFlow() && !taxId.length) {
            store.dispatch(updateTaxInfo(undefined));
        }

        this.displayOrHideTaxDependentFields(taxId)
    }

    displayOrHideTaxDependentFields(taxId: string) {
        if(taxId?.length) {
            this.displayDependentFields();
        } else {
            this.hideDependentFields();
        }
    }

    validateTaxId(taxId: string) {
        if (this.country == this.spain) {
            return this.spainTaxIdValidation(taxId)
        }

        if (this.country == this.mexico) {
            return this.mexicoTaxIdValidation(taxId)
        }


        if (this.country == this.colombia) {
            return this.colombiaTaxIdValidation(taxId)
        }

        return false;
    }

    mexicoTaxIdValidation(taxId: string) {
        const alphaNumericRegex = /^[a-z0-9]+$/i;
        const isValidRegex = alphaNumericRegex.test(taxId);
        return !taxId.length ||
          ((taxId.length == 12 || taxId.length == 13) && isValidRegex)
    }

    colombiaTaxIdValidation(taxId: string) {
        const pattern = /^[0-9]{0,10}$/gim;
        return !taxId.length || !!taxId.match(pattern)
    }

    spainTaxIdValidation(taxId: string) {
        if (this.isResidentOutsideOfSpain()) {
            this.taxErrorMessage = "Tax Id must have 9 numbers or letters.";
            return true;
        }

        if (this.isSpanishCitizen()) {
            this.taxErrorMessage = "No se olvide de incluir la letra del DNI y si su DNI empieza por cero, inclúyalo también";
            const pattern = /^[0-9]{8}[a-z]$/gim;
            return !!taxId.match(pattern);
        }

        if (this.isSpainResident()) {
            this.taxErrorMessage = "Tax id / DNI tiene que empezar con X, Y o Z, después siete números, y terminar con una letra";
            const pattern = /^[xyz][0-9]{7}[a-z]$/gim;
            return !!taxId.match(pattern);

        }

        if (this.isSpainCompany()) {
            this.taxErrorMessage = "Tax id / CIF tiene que empezar con una letra, y terminar con ocho números";
            const pattern = /^[a-z][0-9]{8}$/gim;
            return !!taxId.match(pattern);
        }

        return false;
    }

    renderNameOnInvoice() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="nameOnInvoice" class="${this.labelFieldClass}">${this.nameOnInvoiceLabel}</label>
                    <input
                      type="text"
                      class="form-control ${(!this.isNameOnInvoiceValid && this.nameOnInvoiceTouched) ? 'is-invalid': ''}"
                      id="nameOnInvoice"
                      required="${this.isNameOnInvoiceRequired}"
                      aria-required="true"
                      .value="${this.name}"
                      @blur=${this._handleNameOnInvoiceBlur}
                      @input=${(_e: InputEvent) => this.updateNameOnInvoiceValue((_e.target as HTMLInputElement).value)}
                      aria-invalid="${(!this.isNameOnInvoiceValid && this.nameOnInvoiceTouched).toString()}"
                      aria-describedby="name-on-invoice-error"
                    />
                    ${this.getMessageErrorComponent('name-on-invoice-error', (!this.isNameOnInvoiceValid && this.nameOnInvoiceTouched) ? this.nameOnInvoiceErrorMessage : '')}
                </div>
            </div>
        `;
    }

    updateNameOnInvoiceValue(name: string) {
        this.isNameOnInvoiceValid = !!name.length;
        this.isNameOnInvoicePristine = false;
        this.name = name;
    }

    renderZipCode() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="zipCode" class="${this.labelFieldClass}">${this.postalCodeLabel}</label>
                    <input
                      type="text"
                      class="form-control ${(!this.isPostalCodeValid && this.postalCodeTouched) ? 'is-invalid': ''}"
                      id="zipCode"
                      required="${this.isPostalCodeRequired}"
                      aria-required="true"
                      .value="${this.postalCode}"
                      @blur=${this._handlePostalCodeBlur}
                      @focus=${this._handlePostalCodeFocus}
                      @input=${(_e: InputEvent) => this.updatePostalCodeValue((_e.target as HTMLInputElement).value)}
                      aria-invalid="${(!this.isPostalCodeValid && this.postalCodeTouched).toString()}"
                      aria-describedby="postal-code-error"
                    />
                    ${this.getMessageErrorComponent('postal-code-error', (!this.isPostalCodeValid && this.postalCodeTouched) ? this.postalCodeErrorMessage : '')}
                </div>
            </div>
        `;
    }

    updatePostalCodeValue(postalCode: string) {
        this.isPostalCodeValid = !!postalCode.length;
        this.isPostalCodePristine = false;
        this.postalCode = postalCode;
    }

    renderTaxRegime() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectTaxRegime" class="${this.labelFieldClass}">${this.taxRegimeLabel}</label>
                    <div class="select-wrapper">
                        <select
                                id="selectTaxRegime"
                                .value="${this.selectedTaxRegime?.id || 'undefined'}"
                                class="${this.selectFieldClass} ${!this.isTaxRegimeValid && !this.isTaxRegimePristine ? 'is-invalid': ''}"
                                @change=${(_e) => this.updateTaxRegimeValue((_e.target as HTMLInputElement).value)}>
                            
                            <option value="${undefined}" ?selected=${this.selectedTaxRegime === undefined}>Select</option>
                            ${this.taxRegimeOptions.map(option => html`
                                <option value="${option.id}" ?selected=${this.selectedTaxRegime === option}>${option.description}</option>
                        `)}
                        </select>
                        ${this.getMessageErrorComponent('tax-regime-error', !this.isTaxRegimeValid && (!this.isTaxRegimePristine || this.forceShowValidationMessages) ? this.taxRegimeErrorMessage : '')}
                    </div>
                </div>
            </div>
        `;
    }

    updateTaxRegimeValue(value) {
        const selected = Number(value);
        this.selectedTaxRegime = this.taxRegimeOptions.filter(value => value.id === selected)[0];
        this.isTaxRegimePristine = false
        this.isTaxRegimeValid = !!this.selectedTaxRegime;
    }

    renderCfdi() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectCfdi" class="${this.labelFieldClass}">${this.cfdiLabel}</label>
                    <div class="select-wrapper">
                        <select
                                id="selectCfdi"
                                .value="${this.selectedCfdi?.id || 'undefined'}"
                                class="${this.selectFieldClass} ${!this.isCfdiValid && !this.isCfdiPristine? 'is-invalid': ''}"
                                @change=${(_e) => this.updateCfdiValue((_e.target as HTMLInputElement).value)}
                                required="true">
                            <option value="${undefined}" ?selected=${this.selectedCfdi === undefined}>Select</option>
                            ${this.cfdiOptions.map(option => html`
                            <option value="${option.id}" ?selected=${this.selectedCfdi === option}>${option.description}</option>
                        `)}
                        </select>
                        ${this.getMessageErrorComponent('cfdi-error', !this.isCfdiValid && (!this.isCfdiPristine || this.forceShowValidationMessages) ? this.cfdiErrorMessage : '')}
                    </div>
                </div>            
            </div>        
        `;
    }

    updateCfdiValue(value) {
        const selected = value;
        this.selectedCfdi = this.cfdiOptions.filter(value => value.id === selected)[0];
        this.isCfdiPristine = false
        this.isCfdiValid = !!this.selectedCfdi;
    }

    renderPersonInfo() {
        return html`
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectPersonType" class="${this.labelFieldClass}">${this.personTypeLabel}</label>
                    <div class="select-wrapper">
                        <select
                                id="selectPersonType"
                                .value="${this.selectedPersonType?.id || 'undefined'}"
                                class="${this.selectFieldClass} ${!this.isPersonTypeValid && !this.isPersonTypePristine ? 'is-invalid': ''}"
                                @change=${(_e) => this.updatePersonTypeValue((_e.target as HTMLInputElement).value)}>
                            <option value="${undefined}" ?selected=${this.selectedPersonType === undefined}>Select</option>
                            ${this.personTypeOptions.map(option => html`
                                <option value="${option.id}" ?selected=${this.selectedPersonType === option}>${option.description}</option>
                            `)}
                        </select>
                        ${this.getMessageErrorComponent('person-type-error', !this.isPersonTypeValid && (!this.isPersonTypePristine || this.forceShowValidationMessages) ? this.personTypeErrorMessage : '')}
                    </div>                        
                </div>  
            </div>
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectDocumentType" class="${this.labelFieldClass}">${this.documentTypeLabel}</label>
                    <div class="select-wrapper">
                        <select
                                id="selectDocumentType"
                                .value="${this.selectedDocumentType?.id || 'undefined'}"
                                class="${this.selectFieldClass} ${!this.isDocumentTypeValid && !this.isDocumentTypePristine ? 'is-invalid': ''}"
                                @change=${(_e) => this.updateDocumentTypeValue((_e.target as HTMLInputElement).value)}>
                            <option value="${undefined}" ?selected=${this.selectedDocumentType === undefined}>Select</option>
                            ${this.documentTypeOptions.map(option => html`
                                <option value="${option.id}" ?selected=${this.selectedDocumentType === option}>${option.description}</option>
                            `)}
                        </select>
                        ${this.getMessageErrorComponent('document-type-error', !this.isDocumentTypeValid && (!this.isDocumentTypePristine || this.forceShowValidationMessages) ? this.documentTypeErrorMessage : '')}
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectRegion" class="${this.labelFieldClass}">${this.regionLabel}</label>
                    <div class="select-wrapper">
                        <select
                                id="selectRegion"
                                .value="${this.selectedRegion?.id || 'undefined'}"
                                class="${this.selectFieldClass} ${!this.isRegionValid && !this.isRegionPristine ? 'is-invalid': ''}"
                                @change=${(_e) => this.updateRegionValue((_e.target as HTMLInputElement).value)}>
                            <option value="${undefined}" ?selected=${this.selectedRegion === undefined}>Select</option>
                            ${this.regionOptions.map(option => html`
                                <option value="${option.id}" ?selected=${this.selectedRegion === option}>${option.description}</option>
                            `)}
                        </select>
                        ${this.getMessageErrorComponent('region-error', !this.isRegionValid && (!this.isRegionPristine || this.forceShowValidationMessages) ? this.regionErrorMessage : '')}
                    </div>                        
                </div>
            </div>
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectCity" class="${this.labelFieldClass}">${this.cityLabel}</label>
                    <div class="select-wrapper">
                        <select
                            id="selectCity"
                            ?disabled=${this.isCityDisabled}
                            .value="${this.selectedCity?.id || 'undefined'}"
                            class="${this.selectFieldClass} ${!this.isCityValid && !this.isCityPristine ? 'is-invalid': ''}"
                            @change=${(_e) => this.updateCityValue((_e.target as HTMLInputElement).value)}>
                            <option value="${undefined}" ?selected=${this.selectedCity === undefined}>Select</option>
                            ${this.cityOptions.map(option => html`
                                <option value="${option.id}" ?selected=${this.selectedCity === option}>${option.name}</option>
                            `)}
                        </select>
                        ${this.getMessageErrorComponent('city-error', !this.isCityValid && (!this.isCityPristine || this.forceShowValidationMessages) ? this.cityErrorMessage : '')}
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="form-group">
                    <label for="selectRepresentation" class="${this.labelFieldClass}">${this.representationLabel}</label>
                    <div class="select-wrapper">
                        <select
                                id="selectRepresentation"
                                .value="${this.selectedRepresentation?.id || 'undefined' }"
                                class="${this.selectFieldClass} ${!this.isRepresentationValid && !this.isRepresentationPristine ? 'is-invalid': ''}"
                                @change=${(_e) => this.updateRepresentationValue((_e.target as HTMLInputElement).value)}>
                            <option value="${undefined}" ?selected=${this.selectedRepresentation === undefined}>Select</option>
                            ${this.representationOptions.map(option => html`
                            <option value="${option.id}" ?selected=${this.selectedRepresentation === option}>${option.name} - ${option.description}</option>`)}
                        </select>
                        ${this.getMessageErrorComponent('city-error', !this.isRepresentationValid && (!this.isRepresentationPristine || this.forceShowValidationMessages) ? this.representationErrorMessage : '')}
                    </div>
                </div>
            </div>
        `;
    }

    renderCityField() {
        this.selectedCity = undefined;
        this.isCityPristine = true;
        this.isCityValid = false;
    }

    updatePersonTypeValue(value) {
        const selected = Number(value);
        this.selectedPersonType = this.personTypeOptions.filter(value => value.id === selected)[0];
        this.isPersonTypePristine = false
        this.isPersonTypeValid = !!this.selectedPersonType;
    }

    updateDocumentTypeValue(value) {
        const selected = Number(value);
        this.selectedDocumentType = this.documentTypeOptions.filter(value => value.id === selected)[0];
        this.isDocumentTypePristine = false
        this.isDocumentTypeValid = !!this.selectedDocumentType;
    }

    updateRegionValue(value) {
        const selected = Number(value);
        this.selectedRegion = this.regionOptions.filter(value => value.id === selected)[0];
        this.isRegionPristine = false
        if(!this.selectedRegion) {
            this.isRegionValid = false;
            this.isCityDisabled = true;
            this.cityOptions = [];
        } else {
            this.isRegionValid = true;
            this.isCityDisabled = false;
            this.cityOptions = getCities(this.country, this.selectedRegion.id);
        }
        this.renderCityField()
    }

    updateCityValue(value) {
        const selected = value;
        this.selectedCity = this.cityOptions.filter(value => value.id === selected)[0];
        this.isCityPristine = false
        this.isCityValid = !!this.selectedCity;
    }

    updateRepresentationValue(value) {
        const selected = value;
        this.selectedRepresentation = this.representationOptions.filter(value => value.id === selected)[0];
        this.isRepresentationPristine = false
        this.isRepresentationValid = !!this.selectedRepresentation;
    }

    loadForm() {
        switch (this.country) {
            case this.mexico:
                return this.loadMexicoFields()
            case this.colombia:
                return this.loadColombiaFields()
            case this.spain:
                return  this.loadSpainFields()
            default :
                return html``
        }
    }

    loadMexicoFields() {
        if(this.country == this.mexico) {
            return html`
                ${this.renderTaxId() }
                ${this.showDependentFields ? this.renderNameOnInvoice() : html`` }
                ${this.showDependentFields ? this.renderZipCode() : html`` }                
                ${this.showDependentFields ? this.renderTaxRegime() : html`` }
                ${this.showDependentFields ? this.renderCfdi() : html`` }                
            `
        }
        return html``
    }

    loadSpainFields() {
        if (this.country == this.spain) {
            return html`
                ${this.renderIdentificationType()}                            
                ${this.renderTaxId()}                            
            `
        }
        return html``
    }

    loadColombiaFields() {
        if (this.country == this.colombia) {
            return html`
                ${this.renderTaxId()}
                ${this.showDependentFields ? this.renderNameOnInvoice() : html`` }
                ${this.showDependentFields ? this.renderZipCode() : html`` }
                ${this.showDependentFields ? this.renderTaxRegime() : html`` }
                ${this.showDependentFields ? this.renderPersonInfo() : html`` }
            `
        }

        return html``
    }

    isSupportedCountry() {
        return this.country == this.mexico ||
          this.country == this.spain ||
          this.country == this.colombia
    }


    /**
     * If form passes basic validation, @returns taxinfo validation response.
     */
    public async validate(): Promise<boolean | void> {
        store.dispatch(updateGlobalMessage({
            id: PAYMENT_MESSAGE_ID,
            message: "",
            type: MessageType.none,
            dismissible: false,
        }));
        await wait(100);
        if(this.isSupportedCountry()) {
            if(this._isFormValid()) {
                const taxInfo: TaxInfoDetails = {
                    taxId: this.taxId,
                    name: this.name,
                    postalCode: this.postalCode,
                    selectedCfdi: this.selectedCfdi,
                    selectedPersonType: this.selectedPersonType,
                    selectedDocumentType: this.selectedDocumentType,
                    selectedRegion: this.selectedRegion,
                    selectedCity: this.selectedCity,
                    selectedRepresentation: this.selectedRepresentation,
                    selectedTaxRegime: this.selectedTaxRegime,
                    selectedIdentificationType: this.selectedIdentificationType
                };
                if(taxInfo?.taxId) {
                    store.dispatch(updateTaxInfo(taxInfo));
                }
            } else {
                store.dispatch(updateGlobalMessage({
                    id: PAYMENT_MESSAGE_ID,
                    message: this.taxErrorAlertMessage,
                    type: MessageType.danger,
                    dismissible: false,
                }));
                throw new Error("Tax information is not valid");
            }
        }
        return true;
    }

    _isFormValid(): boolean {
        if(this.country == this.spain && this.validateTaxId(this.taxId)){
            return true;
        } else if(this.country == this.colombia && this.validateTaxId(this.taxId) && this.isNameOnInvoiceValid && this.isPostalCodeValid
          && this.isTaxRegimeValid && this.isPersonTypeValid && this.isDocumentTypeValid && this.isRegionValid
          && this.isCityValid && this.isRepresentationValid) {
            return true;
        } else if(this.country == this.mexico && this.validateTaxId(this.taxId) && this.isNameOnInvoiceValid && this.isPostalCodeValid
          && this.isTaxRegimeValid && this.isCfdiValid) {
            return true;
        }
        return false;
    }

    private _handleTaxIdBlur() {
        this.taxIdTouched = true;
    }

    private _handleTaxIdFocus() {
        this.taxIdTouched = false;
        this.isTaxIdPristine = true;
    }

    private _handleNameOnInvoiceBlur() {
        this.nameOnInvoiceTouched = true;
    }

    private _handleNameOnInvoiceFocus() {
        this.nameOnInvoiceTouched = false;
        this.isNameOnInvoicePristine = true;
    }

    private _handlePostalCodeBlur() {
        this.postalCodeTouched = true;
    }

    private _handlePostalCodeFocus() {
        this.postalCodeTouched = false;
        this.isPostalCodePristine = true;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'mhecomm-tax-info': TaxInfo;
    }
}
